import { useLang } from "@/i18n";

const Marquee = () => {
  const { t } = useLang();
  const row = [...t.marquee, ...t.marquee];
  return (
    <div
      data-testid="editorial-marquee"
      className="relative border-y border-white/10 bg-[#0A0A0A] py-6 overflow-hidden"
    >
      <div className="marquee-track items-center gap-10 pr-10">
        {[0, 1].map((half) => (
          <div key={half} className="flex items-center gap-10 shrink-0">
            {row.map((p, i) => (
              <span key={`${half}-${i}`} className="flex items-center gap-10 shrink-0">
                <span className="font-display text-3xl md:text-5xl uppercase tracking-wider text-neutral-700">
                  {p}
                </span>
                <span className="h-2 w-2 bg-[#D91624] rotate-45 shrink-0" />
              </span>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
